/**
 * Onboarding navigation helpers.
 *
 * `withFromOnboarding` tags a destination URL with `from=onboarding` while
 * preserving any existing query params and hash, so the destination page can
 * render a `ReturnToSetupBanner` linking back to the setup checklist.
 *
 * OB.3 — Buyer Onboarding completion slice.
 */

const FROM_ONBOARDING_PARAM = "from";
const FROM_ONBOARDING_VALUE = "onboarding";

/** Appends `from=onboarding` to a URL while preserving existing query params and hash. */
export function withFromOnboarding(url: string): string {
  const hashIndex = url.indexOf("#");
  const hash = hashIndex >= 0 ? url.slice(hashIndex) : "";
  const withoutHash = hashIndex >= 0 ? url.slice(0, hashIndex) : url;

  const queryIndex = withoutHash.indexOf("?");
  const path = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
  const existingQuery = queryIndex >= 0 ? withoutHash.slice(queryIndex + 1) : "";

  const params = new URLSearchParams(existingQuery);
  params.set(FROM_ONBOARDING_PARAM, FROM_ONBOARDING_VALUE);

  return `${path}?${params.toString()}${hash}`;
}

/** True when the given `location.search` string carries the onboarding return marker. */
export function isFromOnboarding(search: string): boolean {
  return new URLSearchParams(search).get(FROM_ONBOARDING_PARAM) === FROM_ONBOARDING_VALUE;
}
